import { render, staticRenderFns } from "./LoadingPlaceholder.vue?vue&type=template&id=456f67de"
import script from "./LoadingPlaceholder.vue?vue&type=script&lang=js"
export * from "./LoadingPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./LoadingPlaceholder.vue?vue&type=style&index=0&id=456f67de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports